module.exports = __webpack_public_path__ + "img/showcase-hotsheet-en-ca.05827bd2.jpg";